import Typography from '@material-ui/core/Typography';

function Logo() {
  return (
    <div style={{ display: 'flex' }}>
      <Typography
        variant="h6"
        style={{
          margin: 'auto 0', // 上下・左右
        }}
      >
        しいね産業 (株)
      </Typography>
    </div>
  );
}

export default Logo;
